import React from 'react'
import styled from 'styled-components'
import Checkbox from 'elements/Checkbox'
import HeaderLabel from 'elements/HeaderLabel'

const CheckboxContainer = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1.5rem;
  width: 3.75rem;
`

export default function defaultHeaderRowRenderer ({
  className,
  style,
  selected,
  onSelected
}) {
  return (
    <div className={className} role='row' style={style}>
      <CheckboxContainer>
        <Checkbox
          selected={selected}
          handleClick={onSelected}
        />
      </CheckboxContainer>
      <HeaderLabel
        width='30%'
      >
        Name
      </HeaderLabel>
      <HeaderLabel
        width='20%'
      >
        Sequence
      </HeaderLabel>
      <HeaderLabel
        width='50%'
      >
        Status
      </HeaderLabel>
    </div>
  )
}
